import SelectionInput from './SelectionInput';
import { SelectionInputProps, OptionSelectionProps } from './types';

export type { SelectionInputProps, OptionSelectionProps };
export default SelectionInput;
